import { baseSplitApi } from "../baseApi"


const newsFeed = '/notes'

const newsFeedTagText = 'NOTES'

export const notesApi = baseSplitApi.injectEndpoints({
    endpoints: (build) => ({
        getNotes: build.query({
            query: () => {
                return {
                    url: newsFeed,
                    method: 'GET'
                }
            },
            providesTags: [newsFeedTagText]
        }),
        addNotes: build.mutation({
            query: (newsFeedData) => {
                return {
                    url: newsFeed,
                    method: 'POST',
                    body: newsFeedData
                }
            },
            invalidatesTags: [newsFeedTagText]
        }),
    }),
    overrideExisting: false,
})


export const { useGetNotesQuery,useAddNotesMutation} = notesApi

